module.exports = __webpack_public_path__ + "static/media/HOR_A.59f479d7.png";